import { JobSearchType } from '@commenda/types/src/root-fi/types';
import { SWRFetcher } from '@commenda/utils';
import { JobType } from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';

export function useGetRootfiJob(corporationId: number, token: string) {
  const {
    data,
    error,
    mutate,
  }: {
    mutate: KeyedMutator<unknown>;
    error: unknown;
    data: JobSearchType;
  } = useSWR(
    `job/search?jobType=${JobType.rootfi_sync}&corporationId=${corporationId}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
